import React from 'react';
import styled from 'styled-components';
import NameAvatar from '../../UI/NameAvatar';
import { getRandomColor } from '../../constants/palette';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../store/hooks';

interface AvatarProps {
  title: string;
  description: string;
  image: string;
  color?: {
    main: string;
    light: string;
  };
  managed_recruiter?: boolean;
  managing_company_name?: string;
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const UserAvatar = styled(NameAvatar)`
  min-width: 2.5rem;
  min-height: 2.5rem;
  width: 2.5rem;
  height: 2.5rem;
  margin-right: 0.5rem;
  border-radius: 50%;
  border: ${(props) => (props.image ? '1px solid #dae5ec' : 'none')};
  display: flex;
  & img {
    height: auto;
    object-position: center;
    object-fit: contain;
  }
`;

const Text = styled.div``;

const Title = styled.h4`
  font-size: 0.875rem;
  font-weight: bold;
  line-height: 1.43;
  color: #061c2e;
  margin: 0;
`;

const Description = styled.p`
  font-size: 0.75rem;
  line-height: 1.33;
  color: #627d95;
  margin: 0.25rem 0 0;
`;

// Add styled components for the management pill
const ManagedByWrapper = styled.div`
  margin-top: 0rem;
  margin-bottom: 0rem;
`;

const ManagedByText = styled.span`
  display: inline-block;
  font-size: 0.6rem;
  color: #627d95;
  font-weight: 500;
  background-color: #f0f2f5;
  padding: 0.1em 0.6em;
  border-radius: 1em;
  line-height: 1.3;
`;

const NameImage = ({ title, description, image, color, managed_recruiter, managing_company_name }: AvatarProps) => {
  const { t } = useTranslation();
  const { user } = useAppSelector((state) => state.user);

  // Only show the pill if managed by another company (not user's own)
  const currentCompanyName = user?.company?.name?.trim().toLowerCase() || '';
  const managingCompanyName = managing_company_name?.trim().toLowerCase() || '';
  const showManagedBy =
    managed_recruiter === true &&
    !!managing_company_name &&
    managingCompanyName &&
    managingCompanyName !== currentCompanyName;

  return (
    <Wrapper>
      <UserAvatar
        size={'large'}
        image={image}
        name={title}
        color={color ? color : getRandomColor()}
      />
      <Text>
        <Title>{title}</Title>
        {showManagedBy && (
          <ManagedByWrapper>
            <ManagedByText>
              {t('MANAGED_BY_USER', { name: managing_company_name })}
            </ManagedByText>
          </ManagedByWrapper>
        )}
        {description && <Description>{description}</Description>}
      </Text>
    </Wrapper>
  );
};

export default NameImage;
